import { useTranslation } from "@refinedev/core";
import DateTimePicker from "components/datetimePicker";
import Input from "components/input";
import { Label } from "components/label";
import { IAdditionalSetupForm, ISimpleEventDetail } from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";

export const ChangeRegistrationInformation = ({
  isEdit,
}: {
  isEdit: boolean;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<IAdditionalSetupForm>(); // retrieve all hook methods

  return isEdit ? (
    <div className="box-container p-4 sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6">
        <div className="sm:col-span-2">
          <Label
            required
            id="change_registration_information.start_change_info_date"
            name={translate(
              "eventSetup.additionalSetup.changeRegistrationInformation.startDate"
            )}
          />
          <Controller
            control={control}
            name="change_registration_information.start_change_info_date"
            render={({ field: { onChange, value = "" } }) => {
              return (
                <DateTimePicker
                  id="change_registration_information.start_change_info_date"
                  placeholder={translate(
                    "eventSetup.additionalSetup.changeRegistrationInformation.startDate"
                  )}
                  error={get(
                    errors,
                    `change_registration_information.start_change_info_date.message`,
                    ""
                  )}
                  value={value}
                  onChange={(date: any) =>
                    date === null
                      ? onChange("")
                      : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))
                  }
                />
              );
            }}
          />
          {get(
            errors,
            `change_registration_information.start_change_info_date`,
            ""
          ) ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `change_registration_information.start_change_info_date.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="change_registration_information.end_change_info_date"
            name={translate(
              "eventSetup.additionalSetup.changeRegistrationInformation.endDate"
            )}
          />
          <Controller
            control={control}
            name="change_registration_information.end_change_info_date"
            render={({ field: { onChange, value = "" } }) => {
              return (
                <DateTimePicker
                  id="change_registration_information.end_change_info_date"
                  placeholder={translate(
                    "eventSetup.additionalSetup.changeRegistrationInformation.endDate"
                  )}
                  error={get(
                    errors,
                    `change_registration_information.end_change_info_date.message`,
                    ""
                  )}
                  value={value}
                  onChange={(date: any) =>
                    date === null
                      ? onChange("")
                      : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))
                  }
                />
              );
            }}
          />
          {get(
            errors,
            `change_registration_information.end_change_info_date`,
            ""
          ) ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `change_registration_information.end_change_info_date.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-2">
          <Label
            required
            id="change_registration_information.max_number_of_times_to_update_information"
            name={translate(
              "eventSetup.additionalSetup.changeRegistrationInformation.maxNumberOfTimes"
            )}
          />
          <Input
            id="change_registration_information.max_number_of_times_to_update_information"
            type="number"
            placeholder={translate(
              "eventSetup.additionalSetup.changeRegistrationInformation.maxNumberOfTimes"
            )}
            error={get(
              errors,
              "change_registration_information.max_number_of_times_to_update_information"
            )}
            {...register(
              "change_registration_information.max_number_of_times_to_update_information",
              {
                valueAsNumber: true,
              }
            )}
          />
          {get(
            errors,
            `change_registration_information.max_number_of_times_to_update_information`,
            ""
          ) ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `change_registration_information.max_number_of_times_to_update_information.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
